import createState from '../vl-places/state';
import * as getters from '../vl-places/getters';
import * as actions from '../vl-places/actions';
import * as mutations from '../vl-places/mutations';

import {createModule} from 'vuex-loopback';
import model from '@/models/place-model';

export default function ({client, onError, onSuccess}) {

  return {
    namespaced: true,
    ...createModule({
      model,
      client,
      onError,
      onSuccess,
      collection: 'places',
      getters,
      actions,
      mutations,
      state: createState(),
    }),
  };
}
